<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-spin" [fullScreen] = "true"><p style="color: white" >{{"loading" | translate}} ...</p></ngx-spinner>
